import cn from 'classname';
import React from 'react';
import './Cell.less';

const Cell = (props) => {
	const { row_number, data, setActiveRow, activeRowNumber, column } = props;
	const payout_changes_usd = (data[`payout_change_${column}`] || []).filter(pc => pc.currency === 'usd');
	const old_payout_usd = payout_changes_usd[0] && payout_changes_usd[0].old_payout;
	const new_payout_usd = payout_changes_usd[0] && payout_changes_usd[payout_changes_usd.length - 1].new_payout;
	const payout_changes_eur = (data[`payout_change_${column}`] || []).filter(pc => pc.currency === 'eur');
	const old_payout_eur = payout_changes_eur[0] && payout_changes_eur[0].old_payout;
	const new_payout_eur = payout_changes_eur[0] && payout_changes_eur[payout_changes_eur.length - 1].new_payout;

	const { isPayoutChangeRow, hasConversionsInRow } = props;

	return (
		<div
			className={cn({
				'table_cell': true,
				'active': row_number === activeRowNumber,
				'affiliate-row': data.affiliate_id && !data.offer_id,
				'offer-row': !!data.offer_id,
				'payout_change_row': isPayoutChangeRow,
				'conversions_in_row': hasConversionsInRow
			})}
			onMouseEnter={setActiveRow.bind(null, row_number)}
			onMouseLeave={setActiveRow.bind(null, -1)}
		>
			<div><b>{Number(data[`total_${column}`]) || 0}</b></div>
			<div className="approved-number"><i>{Number(data[`approved_${column}`]) || 0}</i></div>
			{
				old_payout_usd && new_payout_usd &&
				<div className="payouts-change">
					<span className="old">{old_payout_usd}$</span>
					<span className="new">{new_payout_usd}$</span>
				</div>
			}
			{
				old_payout_eur && new_payout_eur &&
				<div className="payouts-change">
					<span className="old">{old_payout_eur}€</span>
					<span className="new">{new_payout_eur}€</span>
				</div>
			}
		</div>
	);
};

export default Cell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/Cell.js